import {SignalDefinitionSchema} from '../../signalDefinition';
import {ApiDefinition} from '../definitions';
import {z} from 'zod';

export const MaxSignalDefinitions = 100;

export const SaveSignalDefinition = {
  path: 'signalDefinition/saveSignalDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: SignalDefinitionSchema.omit({
    timestamp: true,
  }).partial({
    id: true,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const DeleteSignalDefinition = {
  path: 'signalDefinition/deleteSignalDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    signalId: z.string(),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;
